import { usePathname } from 'next/navigation'
import { useLayoutEffect, useEffect } from 'react'

import FooterPortal from 'containers/Layouts/Layout/FooterPortal'
import { GamesList } from 'pageContainers/MyGames/components/GamesList'
import Loader from 'src/components/Loader'
import { clearPlayedGames, getPlayedGames, setLoaded } from 'src/store/modules/playedGames/actions'
import { playedGamesLoadedSelector } from 'src/store/modules/playedGames/selectors'
import { useAppDispatch, useAppSelector } from 'store/hooks'

import NoPlayedGames from '../components/NoPlayedGames'

import type { MyGamesPageType } from './types'

function Games(props: MyGamesPageType) {
  const dispatch = useAppDispatch()
  const gamesLoaded = useAppSelector(playedGamesLoadedSelector)
  const pathname = usePathname()

  useLayoutEffect(() => {
    dispatch(clearPlayedGames())
    dispatch(setLoaded(false))
  }, [pathname])

  useEffect(() => {
    dispatch(getPlayedGames(document.cookie))
  }, [pathname])

  if (!gamesLoaded) {
    return <Loader />
  }

  return !props.games?.length ? (
    <>
      <NoPlayedGames gameTypeName={props.gameType} />
      <FooterPortal />
    </>
  ) : (
    <GamesList key={pathname} {...props} />
  )
}
export default Games
